module.exports = __webpack_public_path__ + "gf.cb06b6998271595b4c7d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gf.svg
// module chunks = styles